// components/LoadingSpinner.jsx
import React from "react";

const LoadingSpinner = ({ message = "Loading..." }) => {
  return (
    <div
      className="form__loading d-flex justify-content-center align-items-center"
      style={{ minHeight: "200px" }}
    >
      <div className="spinner-border" role="status">
        <span className="visually-hidden">{message}</span>
      </div>
    </div>
  );
};

export default LoadingSpinner;
